import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import DownloadButtons from "../DownloadButtons/DownloadButtons";
import { API_BASE_URL } from "../../config";

const NoLeaveReport = () => {

  const today = new Date().toLocaleDateString("en-CA");

  const [filters, setFilters] = useState({
    from_date: today,
    to_date: today,
    dept_id: 0,
  });

  const [departments, setDepartments] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ Fetch Departments Only
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const res = await axios.get(API_BASE_URL + "/showdepartment", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        setDepartments(res.data.departments || res.data.data || res.data);
      } catch (err) {
        toast.error("Failed to load departments");
      }
    };

    fetchDepartments();
  }, []);

  // ✅ API Call Only When Clicking Button
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!filters.from_date || !filters.to_date) {
      toast.error("Please select From Date and To Date");
      return;
    }

    if (filters.from_date > filters.to_date) {
      toast.error("From Date cannot be greater than To Date");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(
        API_BASE_URL + "/withoutleave",
        {
          from_date: filters.from_date,
          to_date: filters.to_date,
          dept_id: filters.dept_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      setRecords(res.data.records || []);
      toast.success("Report Loaded Successfully!");
    } catch (error) {
      toast.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  };

  const filteredRecords = records.filter((item) =>
    `${item.employee_id} ${item.employee_name} ${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const exportData = filteredRecords.map(({ user_id, ...rest }) => ({
    ...rest,
    from_date: filters.from_date,
    to_date: filters.to_date,
  }));

  const columns = [
    {
      name: "Employee ID",
      selector: (row) => row.employee_id,
      sortable: true,
    },
    {
      name: "Employee Name",
      selector: (row) => row.employee_name,
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.department_name,
      sortable: true,
    },
  ];

  return (
    <div className="container-fluid mt-4">
      <ToastContainer position="bottom-right" />
 <div className="mb-3 d-flex flex-wrap gap-2">
          <a href="/leave-report" className="btn btn-outline-secondary btn-sm">
            Leave Report
          </a>
          <a href="/no-leave" className="btn btn-info btn-sm">
            Unavailed Leave
          </a>
        </div>

 
      <div className="card shadow-sm mb-4">
        <div className="card-header">
          {/* <h5> Unavailed Leave Report</h5> */}
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row g-3 align-items-end">

              {/* From Date */}
              <div className="col-md-3">
                <label>From Date</label>
                <DatePicker
                  selected={new Date(filters.from_date)}
                  onChange={(date) =>
                    setFilters((prev) => ({
                      ...prev,
                      from_date: date
                        ? date.toLocaleDateString("en-CA")
                        : "",
                    }))
                  }
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                />
              </div>

              {/* To Date */}
              <div className="col-md-3">
                <label>To Date</label>
                <DatePicker
                  selected={new Date(filters.to_date)}
                  onChange={(date) =>
                    setFilters((prev) => ({
                      ...prev,
                      to_date: date
                        ? date.toLocaleDateString("en-CA")
                        : "",
                    }))
                  }
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  minDate={new Date(filters.from_date)}
                />
              </div>

              {/* Department */}
              <div className="col-md-3">
                <label>Department</label>
                <Select
                  options={departments.map((dept) => ({
                    value: dept.department_id,
                    label: dept.department_name,
                  }))}
                  isClearable
                  placeholder="All Departments"
                  onChange={(selected) =>
                    setFilters((prev) => ({
                      ...prev,
                      dept_id: selected ? selected.value : 0,
                    }))
                  }
                />
              </div>

              {/* Button */}
              <div className="col-md-2">
                <button type="submit" className="btn btn-primary w-100">
                  {loading ? "Loading..." : "Get Report"}
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>

      <div className="card">
        <h6 className="card-header text-danger">
          Unavailed Leave List
        </h6>

        <div className="card-body">

          <div className="d-flex justify-content-between mb-3 align-items-center">
            <DownloadButtons
              data={exportData}
              filename="Unavailed_leave"
            />

            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search..."
              style={{ width: "220px" }}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

         <DataTable
  columns={columns}
  data={filteredRecords}
  progressPending={loading}
  pagination
  paginationPerPage={10} // default rows per page
  paginationRowsPerPageOptions={[10, 25, 50, 100]} // 👈 your options
  highlightOnHover
  striped
  dense
  noDataComponent={
    <div className="p-3 text-danger fw-bold">
      No records found
    </div>
  }
/>

        </div>
      </div>
    </div>
  );
};

export default NoLeaveReport;
